const colors = 
{
    red: 'red',
    darkBlue: '#365472',
    orange: '#EF7A30',
    gradientOrange: 'linear-gradient(to right, #EF7A30, #F0A13D)',
    lightOrange:'#FDEBE0',
    hoverOrange: '#F3A967',
    gray: '#B4B4B4',
    mediumGray: '#E1E6ED',
    lightGray: '#F0F0F0',
    epOrange: 'linear-gradient(to right, #430089, #82ffa1)',
    cyan:'#F5F7FA',
    purple: '#5939DF',
    hoverPurple:'#866BF4',
    white: '#FFFFFF',
    lightGreen: '#66CD78',
    green: '#4cd038',
    lightBlue: "#F3F5F7",
    utilityColor: "#F2F4F6",
    darkRed:'#B60E01',
    blue:'#2e96ff',
    yellow:'#fcca03',
    veryLightGreen:'#E8F8EB',
    veryLightBlue:'#E8F6FE',
    veryLightOrange:'#FDF1E2'
}

export default colors